<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h5>Programación de autorización</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                        <date-picker v-model="form.fecha_programacion_autorizacion" type="date" id="desde"></date-picker>
                        <label>Fecha*</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button type="button" class="btn-success" @click="programar">
                <i class="fa fa-tasks"></i><span>Programar</span>
            </button>
            <button v-show="fechaProgramacion !== ''" class="btn-danger btn--text" type="button" @click="anularProgramacion">
                <i class="fa fa-ban"></i><span>Anular programación</span>
            </button>
            <button class="btn-primary btn--text" type="button" @click="$emit('cerrar')">
                <i class="fa fa-times"></i><span>Cerrar</span>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        fechaProgramacion: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function () {
        return {
            form: {
                fecha_programacion_autorizacion: this.fechaProgramacion,
                tipo: 'P'
            },
            errores: {}
        };
    },
    methods: {
        ejecutarPost: function () {
            axios.post(url + '/programar-autorizacion/' + this.id, this.form).then(({data}) => {
                swal('Los cambios fueron realizados.', 'Realizado', 'success');
                if (this.form.tipo === 'P') {
                    this.$emit('programado', this.form.fecha_programacion_autorizacion);
                }
                else {
                    this.$emit('anulado');
                }
            }).catch(({response}) => {
                let status = response.status;
                if (status == 422) {
                    swal('Hay errores en el formulario.', 'Error', 'error');
                    this.errores = response.data.errors;
                }
                else 
                    swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        },
        programar: function () {
            this.form.tipo = 'P';
            let that = this;
            swal({
                title: '¿Desea programar la autorización del comprobante para la fecha ' + this.form.fecha_programacion_autorizacion + '?',
                text: "Se enviará al SRI a la fecha asignada y se cambiará su fecha de emisión.",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Programar',
                cancelButtonText : 'No'
            }).then(function (result) {
                if (result.value) {
                    that.ejecutarPost();
                }
            });
        },
        anularProgramacion: function () {
            this.form.tipo = 'A';
            let that = this;
            swal({
                title: '¿Desea anular la programación de este comprobante?',
                text: "El comprobante ya no estará programado",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Anular',
                cancelButtonText : 'No'
            }).then(function (result) {
                if (result.value) {
                    that.ejecutarPost();
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ProgramarFechaAutorizacion.vue